/* ItsXXXmas 23/10 : cadeaux « Buy 3, Get 2 » (modèle lv-ring-box Loovina).
   5 Gift Card Books ou plus dans le panier = 1 « Christmas Stickers - Free Gift » + 1 « Tape Dots - Free Gift » (0 $) ;
   moins de 5 livres = aucun cadeau. Resynchronise après chaque appel /cart/add|change|update|clear et au chargement.
   ponytail: correction côté navigateur seulement ; un checkout lancé pendant la synchro (~1 s) peut partir sans cadeau.
   Blindage serveur possible plus tard avec une Cart Transform Function. */
(() => {
  const s = document.currentScript;
  const GIFTS = ((s && s.dataset.variants) || '').split(',').map(Number).filter(Boolean);
  const BOOK = s && s.dataset.book;
  const MIN = 5;
  if (!GIFTS.length || !BOOK) return;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const baseFetch = window.fetch.bind(window);
  let busy = false;
  let again = false;

  async function sync() {
    if (busy) { again = true; return; }
    busy = true;
    try {
      const cart = await baseFetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const books = cart.items.filter((i) => i.handle === BOOK).reduce((n, i) => n + i.quantity, 0);
      const want = books >= MIN ? 1 : 0;
      const updates = {};
      GIFTS.forEach((id) => {
        const have = cart.items.filter((i) => i.variant_id === id).reduce((n, i) => n + i.quantity, 0);
        if (have !== want) updates[id] = want;
      });
      if (Object.keys(updates).length) {
        const r = await baseFetch(root + 'cart/update.js?itx_fg=1', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates }),
        });
        if (r.ok && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'itx-free-gifts' }); // re-rend le tiroir / la page panier
        }
      }
    } catch (e) {
      console.error('[itx-free-gifts]', e);
    } finally {
      busy = false;
      if (again) { again = false; sync(); }
    }
  }

  window.fetch = function (input, init) {
    const p = baseFetch(input, init);
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (/\/cart\/(add|change|update|clear)/.test(url) && url.indexOf('itx_fg=1') < 0) {
      p.then((r) => { if (r.ok) setTimeout(sync, 0); }).catch(() => {});
    }
    return p;
  };

  sync();
  window.addEventListener('pageshow', (e) => { if (e.persisted) sync(); });
})();
